import { Link } from 'react-router-dom';
import { Stack } from 'react-bootstrap';

export default function NoPermissionPage() {
  return (
    <div
      style={{
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '2rem'
      }}
    >
      <Stack gap={3} className="align-items-center">
        <div>
          <i className="ti ti-lock" style={{ fontSize: '4rem', color: '#d9534f' }}></i>
        </div>

        <h2 className="fw-bold">Access Denied</h2>
        <p className="text-muted" style={{ maxWidth: 420 }}>
          You do not have permission to view this page. Please contact your administrator if you think this is a mistake.
        </p>

        <Link to="/" className="btn btn-primary">
          Go to Dashboard
        </Link>
      </Stack>
    </div>
  );
}
